const STATUS_CONFIG = {
  booked: { label: "Booked", className: "bg-slate-100 text-slate-700" },
  manifested: { label: "Manifested", className: "bg-indigo-100 text-indigo-700" },
  connected: { label: "Connected", className: "bg-cyan-100 text-cyan-700" },
  picked_up: { label: "Picked Up", className: "bg-blue-100 text-blue-700" },
  in_transit: { label: "In Transit", className: "bg-orange-100 text-orange-700" },
  out_for_delivery: { label: "Out for Delivery", className: "bg-yellow-100 text-yellow-700" },
  delivered: { label: "Delivered", className: "bg-emerald-100 text-emerald-700" },
  cancelled: { label: "Cancelled", className: "bg-red-100 text-red-700" },
  ndr: { label: "NDR", className: "bg-red-100 text-red-700" },
};

export default function StatusBadge({ status }) {
  const cfg = STATUS_CONFIG[status] || { label: status, className: "bg-slate-100 text-slate-700" };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wider ${cfg.className}`}>
      {cfg.label}
    </span>
  );
}
